var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-fade-transition',{attrs:{"mode":"out-in"}},[(_vm.mode === _vm.modes.roulette)?_c('result-revealer',{attrs:{"result":_vm.result,"resources":{
				pick2Img: _vm.pick2,
				pick3Img: _vm.pick3,
				pick4Img: _vm.pick4,
				pick5Img: _vm.pick5
			}},on:{"finish":_vm.handleResultsDone},scopedSlots:_vm._u([{key:"logo",fn:function(){return [_c('v-img',{attrs:{"contain":"","src":_vm.logo}})]},proxy:true}],null,false,2952524856)}):(_vm.mode === _vm.modes.winningNumbers)?_c('winning-numbers',{attrs:{"result":_vm.result}}):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }